import AttachFile from '@mui/icons-material/AttachFile';
import PropTypes from 'prop-types';
import React from 'react';
import PALETTE from 'react/shared/theme/palette';

export default function AttachmentCell({ value }) {
  if (value) {
    return (
      <>
        <AttachFile style={{ fill: PALETTE.black, fontSize: '18px', marginBottom: '-3px' }} />
        Uploaded
      </>
    );
  }

  return <a href="#">+Add</a>;
}

AttachmentCell.propTypes = {
  value: PropTypes.bool,
};
